import { isString } from 'utils/string';

export const quoteWrap = (
  text: unknown = '',
  quoteChar: unknown = '“',
): string => {
  if (!isString(text) || !isString(quoteChar)) {
    throw new TypeError('Expected arguments to be a string');
  }

  const QUOTE_REGEX = /"|'|`|“/;
  const firstChar = text.trim().charAt(0);
  const lastChar = text.trim().charAt(text.length - 1);
  let result = text;

  if (firstChar !== quoteChar && QUOTE_REGEX.test(firstChar)) {
    // If the text has different quotes, replace it
    result = quoteChar + result.substring(1);
  } else if (firstChar !== quoteChar) {
    result = quoteChar + result;
  }

  if (lastChar !== quoteChar && QUOTE_REGEX.test(lastChar)) {
    result = result.substring(0, result.length - 1) + quoteChar;
  } else if (lastChar !== quoteChar) {
    // No trailing quotes, add it
    result += quoteChar;
  }

  return result;
};
